import { useParams } from 'react-router-dom';
import CountUp from 'react-countup';
import { Trans, useTranslation } from 'react-i18next';
import { Globe, Link2, LucideIcon, ShieldBan, ShieldX } from 'lucide-react';
import './DnsComponent.scss';
import '../../design-system/index.css';
import { DnsWidget } from '../Dns-widget/DnsWidget';

type DnsComponentProps = {
  box1Title: string;
  box1Quantity: number;
  box1Icon: string;
  box2Title: string;
  box2Quantity: number;
  box2Icon: string;
  box3Title: string;
  box3Quantity: number;
  box3Icon: string;
  box4Title: string;
  box4Quantity: number;
  box4Icon: string;
  type: string;
  deviceId?: any;
  haandleId?: any;
  darkMode?: boolean;
};

export const DnsComponent = (props: DnsComponentProps) => {
  const { operatorId } = useParams();
  const { t } = useTranslation();

  const operatorNames = localStorage.getItem('operatorList');

  const operatorNameArray = operatorNames
    ? JSON.parse(operatorNames)?.find((item: { key: string }) => item.key === operatorId)
    : null;

  const subject =
    props.type === 'all'
      ? operatorNameArray?.name || t('activity.page.subjectOperator', { id: operatorId })
      : props.type === 'router'
      ? t('activity.page.subjectRouter', { id: props.haandleId })
      : props.type === 'device'
      ? t('activity.page.subjectDevice', { id: props.deviceId })
      : '';

  // Requests/visits in mint, blocked counts in red
  const kpis: { title: string; value: number; icon: LucideIcon; tone?: string }[] = [
    { title: props.box1Title, value: props.box1Quantity, icon: Globe },
    { title: props.box2Title, value: props.box2Quantity, icon: Link2 },
    { title: props.box3Title, value: props.box3Quantity, icon: ShieldBan, tone: 'danger' },
    { title: props.box4Title, value: props.box4Quantity, icon: ShieldX, tone: 'danger' },
  ];

  return (
    <div className="bd dns-page" data-theme={props.darkMode ? 'dark' : 'light'} data-accent="mint">
      <section className="dns-wrap">
        <header className="dns-hd">
          <span className="dns-eyebrow">{t('activity.page.eyebrow')}</span>
          <h1 className="bd-h1 dns-title">
            <Trans
              i18nKey="activity.page.title"
              values={{ subject }}
              components={{ subject: <span className="dns-subject" /> }}
            />
          </h1>
          <span className="bd-body">{t('activity.page.subtitle')}</span>
        </header>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
          {kpis.map((kpi) => {
            const Icon = kpi.icon;
            return (
              <div key={kpi.title} className={`bd-card bd-kpi ${kpi.tone || ''}`}>
                <span className="bd-kpi-icon">
                  <Icon size={18} strokeWidth={1.75} />
                </span>
                <div className="bd-kpi-text">
                  <span className="bd-kpi-label" title={kpi.title}>{kpi.title}</span>
                  <CountUp
                    className="bd-stat-num bd-kpi-num"
                    preserveValue={true}
                    end={Number(kpi.value) || 0}
                    duration={2}
                    separator=","
                  />
                </div>
              </div>
            );
          })}
        </div>

        <DnsWidget type={props.type} deviceId={props.deviceId} haanndleId={props.haandleId} page={'main'} />
      </section>
    </div>
  );
};
